<template>
    <v-layout justify="center">
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar dark color="secondary">
                    <v-btn icon dark @click="hideDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Calificar a Proveedor</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn :loading="loading" :disabled="!valid" color="transparent" depressed @click="sendRating">Enviar</v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-container>
                    <v-form v-model="valid">
                        <v-layout wrap>

                            <v-flex xs12>
                                <h2 class="subtitle font-weight-light mt-2 mb-2">Que servicio deseas evaluar?</h2>
                                <v-select color="accent" label="Selecciona un servicio" dense filled outlined
                                          :items="serviceOptions" item-text="description" item-value="id"
                                          v-model="service"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <h2 class="subtitle font-weight-light mt-2 mb-2">Que calificacion le daras?</h2>
                                <v-rating
                                        background-color="secondary"
                                        color="accent"
                                        v-model="stars"></v-rating>
                            </v-flex>
                            <v-flex xs12>
                                <h2 class="subtitle font-weight-light mt-4 mb-2">Comenta tu experiencia</h2>
                                <v-textarea
                                        outlined
                                        :rules="commentsRules"
                                        v-model="comments"
                                        label="Comentarios"
                                        value=""
                                ></v-textarea>
                            </v-flex>
                        </v-layout>

                    </v-form>
                </v-container>

            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        props: ['provider', 'serviceOptions'],
        data(){
            return {
                dialog: false,
                valid: false,
                loading: false,
                stars: 1,
                comments: '',
                service: this.serviceOptions[0],
                commentsRules: [
                    value => (value || '').length >= 12 || 'Debes escribir al menos 12 caracteres',
                ]
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            showDialog(){
                this.dialog = true
            },
            hideDialog(){
                this.dialog = false
            },
            async sendRating(){

                var vm = this
                vm.loading = true
                const response = await ApiUtils.makePost(`provider/${vm.provider.id}/rate`, {
                    stars: vm.stars,
                    comment: vm.comments,
                    service_item_id: vm.service.id
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Error intentando enviar calificacion')
                    return
                }

                vm.$emit('success')
                vm.hideDialog()

            }
        },
        computed: {},
        watch: {
            dialog(val){
                this.$emit('change', val)
            }
        }
    }
</script>
